import { render, staticRenderFns } from "./Actualizar.vue?vue&type=template&id=5c12293b"
import script from "./Actualizar.vue?vue&type=script&lang=js"
export * from "./Actualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports